<div class="container pt-10 pt-md-11 text-center position-relative">
  <div class="position-absolute">
  </div>

  <!-- Skeleton Loader para el banner -->
  <div *ngIf="!bannerData?.title" class="skeleton-banner-container">
    <div class="skeleton-title"></div>
    <div class="skeleton-highlight"></div>
    <div class="skeleton-paragraph"></div>
    <div class="skeleton-paragraph short"></div>
    <div class="skeleton-highlights-row">
      <div class="skeleton-highlight-item" *ngFor="let i of [1,2,3]"></div>
    </div>
    <div class="skeleton-btn"></div>
  </div>

  <div *ngIf="bannerData?.title" class="row ">
    <div class="banner-container col-lg-8 col-xxl-7 mx-auto  px-0">
      <div class="text-rotator-container">
        <h1 class="display-1 fs-64 text-center text-lg-start mx-0">
          {{bannerData?.title}}
          <span class="highlight">
            {{bannerData?.highlightedText}}
          </span>
          <p *ngIf="bannerData?.afterHighlightedText">{{bannerData?.afterHighlightedText}}</p>
        </h1>
      </div>
      <div class="left pt-10 text-center">
        <p class="fs-24 mb-8 lead description" [innerHTML]="bannerData?.description"></p>
      </div>
      <div *ngIf="bannerData?.showCompanyHighlights"
           [ngClass]="{
             'highlights-row': bannerData?.companyHighlights.length === 3,
             'highlights-grid': bannerData?.companyHighlights.length === 4,
             'text-center': true
           }">
        <div *ngFor="let highlight of bannerData?.companyHighlights" class="highlight-item d-inline-block">
          <img *ngIf="highlight?.img" class="highlight-icon" dynamicImage [baseImageSrc]="highlight?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.sm]" [isIcon]="true" alt="icon" />
          <span class="text-company-highlight">{{ highlight?.title }}</span>
        </div>
      </div>
      <div></div>
      <div class="d-flex justify-content-center">
        <span class="contact">
            <button  (click)="goToLink(bannerData.showHeaderSections.contact_us_link)" mat-button class="btn-banner-contact rounded-xl">
                    <span class="contact-nav-link">{{bannerData.showHeaderSections.contact_us_text}}</span>
            </button>
        </span>
      </div>
    </div>
  </div>

  <img *ngIf="bannerData?.img" loading="lazy" class="home-img hidden-img" dynamicImage [baseImageSrc]="bannerData?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.sm]" alt="banner" />
</div>
